export const GET_SERVER_LIST = "GET_SERVER_LIST";
export const GET_SERVER_LIST_SUCCESSFULL = "GET_SERVER_LIST_SUCCESSFULL";
export const SERVER_FAILED = "SERVER_FAILED";
